import { Label, RadioGroup, RadioGroupItem } from '@massilia/ui'

import type { StopsFilterValue } from '@/lib/schemas/flight-results-search.schema'

import { Route } from '@/routes/_booking/vols.resultats'
import { useFilters } from '@/utils/use-search-params'

import { FilterDrawer } from './filter-drawer'

const STOPS_OPTIONS: { label: string; value: StopsFilterValue }[] = [
  { label: 'Tous les vols', value: 'all' },
  { label: 'Direct uniquement', value: 'direct' },
  { label: '1 escale maximum', value: 'one_stop_max' },
  { label: '2 escales maximum', value: 'two_stops_max' },
]

export function StopsFilter() {
  const {
    filters: { filterStops },
    setFilters,
  } = useFilters(Route.id)

  return (
    <FilterDrawer title="Escales">
      <RadioGroup
        className="flex flex-col gap-2"
        onValueChange={(val) => {
          setFilters({ filterStops: val })
        }}
        value={filterStops}
      >
        {STOPS_OPTIONS.map((option) => (
          <Label
            className="flex cursor-pointer items-center gap-2"
            htmlFor={`stops-${option.value}`}
            key={option.value}
          >
            <RadioGroupItem id={`stops-${option.value}`} value={option.value} />
            <span className="text-sm text-gray-700">{option.label}</span>
          </Label>
        ))}
      </RadioGroup>
    </FilterDrawer>
  )
}
